module.exports = __webpack_public_path__ + "static/img/lihe.d62c8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/lihe.png
// module id = FVpn
// module chunks = 0